import type { MouseEvent, ReactNode } from 'react';
import { useTranslations } from 'use-intl';
import { Badge, Button, I} from '@leanin/ui';

export type FilterButtonProps = {
  count?: number;
  label?: ReactNode;
  onClick?: (e: MouseEvent<HTMLButtonElement>) => void;
  disabled?: boolean;
  'aria-expanded'?: boolean;
  'aria-controls'?: string;
};

export function FilterButton({
  count = 0,
  label,
  onClick,
  disabled,
  ...aria
}: FilterButtonProps) {
  const t = useTranslations('Common');
  return (
    <Button
      variant="secondary"
      icon={I.filter}
      {...(onClick !== undefined ? { onClick } : {})}
      {...(disabled !== undefined ? { disabled } : {})}
      {...aria}
    >
      {label ?? t('widgets.filters.label')}
      {count > 0 ? (
        <Badge
          tone="primary"
          style={{
            // eslint-disable-next-line @leanin/ui/no-inline-spacing-vars -- Badge primitive does not expose margin props
            marginInlineStart: 'var(--space-sm)',
          }}
        >
          {count}
        </Badge>
      ) : null}
    </Button>
  );
}
